export default {
  licence: {
    isDelete: 'licence.isDelete',
    newNname: 'licence.newNname',
    maxCharacters: 'licence.maxCharacters',
    minCharacters: 'licence.minCharacters',
    hi: 'general.hi',
    backToDashboard: 'general.backToDashboard',
    yourLicenceSummary: 'licence.yourLicenceSummary',
    cancelPlan: 'licence.cancelPlan',
    computerID: 'licence.computerID',
    activationCode: 'licence.activationCode',
    validDate: 'licence.validDate',
    activate: 'licence.activate',
    revoke: 'licence.revoke',
    number: 'licence.number',
    nickname: 'licence.nickname',
    status: 'licence.status',
    active: 'licence.active',
    inactive: 'licence.inactive',
    needLicence: 'licence.needLicence',
    upgradePlan: 'licence.upgradePlan',
    cancelPlanPopup: 'licence.cancelPlanPopup',
  },
};
